export default "__VITE_ASSET__6a9671bf__"